import { isEmpty } from "lodash";

export default function extractPaymentMethodsFromOffer(offer) {
  if (!offer?.subscription_methods || isEmpty(offer.subscription_methods)) {
    return {
      paymentMethods: offer?.payment_methods ?? [],
      subscriptionId: null
    };
  }

  return {
    paymentMethods: offer.subscription_methods[0].payment_methods,
    subscriptionId: offer.subscription_methods[0].id
  };
}
